import { Injectable, inject } from '@angular/core'

import { Store } from '@ngrx/store'

@Injectable({ providedIn: 'root' })
export class AiArchitectUtils {
  #store = inject(Store)

  discardDraft(): void {
    this.#transitionfromDraftToEditMode()
  }

  keepDraft(): void {
    // no-op
  }

  #transitionfromDraftToEditMode(): void {
    // no-op
  }
}
